export function applyReenrollment(draftFlow, shouldReenroll, reenrollmentState) {
  var _draftFlow$enrollment;
  draftFlow.shouldReenroll = shouldReenroll;
  const reenrollmentStateToApply = shouldReenroll ? reenrollmentState : [];
  if (draftFlow.classicEnrollmentSettings) {
    draftFlow.classicEnrollmentSettings.reEnrollmentTriggerSets = reenrollmentStateToApply.filter(({
      reEnrollmentTrigger: {
        type
      },
      checked
    }) => checked && type === 'RE_ENROLLMENT_TRIGGER_SET').map(({
      reEnrollmentTrigger
    }) => reEnrollmentTrigger.reEnrollmentTriggerSet);
  } else if (((_draftFlow$enrollment = draftFlow.enrollmentCriteria) === null || _draftFlow$enrollment === void 0 ? void 0 : _draftFlow$enrollment.triggerType) === 'LIST') {
    draftFlow.enrollmentCriteria.reEnrollmentTriggers = reenrollmentStateToApply.filter(({
      reEnrollmentTrigger: {
        type
      },
      checked
    }) => checked && (type === 'ASSOCIATED_LIST' || type === 'FLOW_EVENT_FILTER')).map(({
      reEnrollmentTrigger
    }) => reEnrollmentTrigger);
  }
}